var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDepositWithdraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.333 13.333h5.334v-12H1.333v12h5.334V8H5.333a.667.667 0 010-1.333H26.667a.667.667 0 010 1.333h-1.334v5.333zM8 30.667h16V8H8v22.667zM.667 0h30.666c.368 0 .667.299.667.667V14a.667.667 0 01-.667.667h-6v16c0 .736-.596 1.333-1.333 1.333H8a1.333 1.333 0 01-1.333-1.333v-16h-6A.667.667 0 010 14V.667C0 .299.299 0 .667 0zm18.861 21.139a.67.67 0 00.944 0 .669.669 0 000-.944l-4-4a.669.669 0 00-.944 0l-4 4a.669.669 0 00.944.944L16 17.609l3.528 3.53z",
    fill: "#000"
  })));
}

SvgDepositWithdraw.displayName = 'DepositWithdraw';
export default SvgDepositWithdraw;